import React, { useEffect } from "react";
import { FilterState } from "../Filters/useFilterState";
import { useReviewsState } from "./useReviewsState";
import { Pagination, Spin } from "antd";
import { ReviewsItem } from "./ReviewItem";
import { Space } from "shared/ui";
import { ReviewsProps } from "api/Reviews";
import { LoadingOutlined } from "@ant-design/icons";
import { DisablePage } from "../styled";
import { AnswerQueueStatsBar } from "./AnswerQueueStatsBar";
import { ReevaluateAutoRepliesButton } from "./ReevaluateAutoRepliesButton";

const antIcon = <LoadingOutlined style={{ fontSize: 48 }} spin />;
export const Reviews = (props: { filters: FilterState }) => {
  const {
    reviews,
    fetchData,
    total,
    totalPage,
    totalIsEstimate,
    hasMore,
    updateReview,
    pending,
  } = useReviewsState();

  /** Ant Pagination: total с pageSize=1 = число страниц; при отсутствии следующей страницы не даём уйти за фактический хвост. */
  const paginationPageCount = !hasMore
    ? props.filters.state.page
    : totalPage;
  useEffect(() => {
    const options = {
      marketplace: props.filters.state.marketplace.map((el) => el.value),
      sorting: props.filters.state.sorting.value,
      rating: props.filters.state.rating,
      article: props.filters.state.search,
      status: props.filters.state.status.map((el) => el.value),
      page: props.filters.state.page,
      tag_ids: props.filters.state.tagIds.length
        ? props.filters.state.tagIds
        : undefined,
    };
    fetchData(options);
  }, [props.filters]);

  const handleUpdate = async (id: number, data: Partial<ReviewsProps>) => {
    await updateReview(id, data);
  };

  return (
    <>
      <AnswerQueueStatsBar
        marketplaces={props.filters.state.marketplace.map((el) => el.value)}
      />
      <div>
        <Pagination
          current={props.filters.state.page}
          onChange={(value) =>
            value !== props.filters.state.page &&
            props.filters.update({ page: value })
          }
          total={paginationPageCount}
          pageSize={1}
          showSizeChanger={false}
          style={{ display: "inline-block" }}
        />
        <Space size={24} inline />
        <span style={{ verticalAlign: "top", lineHeight: "35px" }}>
          Найдено: {totalIsEstimate ? "≈ " : ""}
          {total.toLocaleString("ru-RU")}
          {totalIsEstimate ? (
            <span
              style={{ fontSize: 12, color: "#888", marginLeft: 6 }}
              title="Оценка по EXPLAIN PostgreSQL, не полный пересчёт строк."
            >
              (оценка)
            </span>
          ) : null}
        </span>
        <Space size={24} inline />
        <ReevaluateAutoRepliesButton />
      </div>
      <Space size={24} axis="vertical" />
      <>
        <DisablePage disabled={pending}>
          {pending && (
            <Spin
              indicator={antIcon}
              style={{ position: "absolute", margin: 20 }}
            />
          )}
          {reviews.map((el) => (
            <ReviewsItem key={el.id} data={el} onUpdate={handleUpdate} />
          ))}
        </DisablePage>
      </>
      <Space size={24} axis="vertical" />

      <Pagination
        current={props.filters.state.page}
        onChange={(value) =>
          value !== props.filters.state.page &&
          props.filters.update({ page: value })
        }
        total={paginationPageCount}
        pageSize={1}
        showSizeChanger={false}
      />
    </>
  );
};
